
import wx from 'weixin-js-sdk'
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import SearchInput from '../SearchInput/SearchInput.vue';
import {
getShopCat,
search,
addCart,
getCartCount
} from '../../api';
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import Divider from 'vux/src/components/divider/index.vue'

export default {
data() {
return {
activityTitle: null,
activityThumbnail: null,
productList: [],
scrollH: "300px",
shopCat: [],
list: "",
tabIndex: 0,
listIndex: "-1",
isMoreList: false,
loadText: '正在加载',
isLoad: false,
pages: '0',
shop_cat_id: "",
isBallArr: [],
activityId: null,
pagination: {
page: 1,
pageSize: 6
}
}
},
components: {
MHeader,
Scroller,
LoadMore,
SearchInput

},
created() {
if(this.$router.currentRoute && this.$router.currentRoute.query.activityId){
this.activityId = this.$router.currentRoute.query.activityId
}
setTimeout(() => {
var fontSize = parseInt(document.documentElement.style.fontSize);
var h = 0.94;

this.scrollH = document.documentElement.clientHeight - parseInt(h * fontSize) + 'px';
console.log(this.scrollH)
});

},
methods: {
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});

},
navTab(index, activityId) {
this.tabIndex = index;
this.activityId = activityId
this.productList = []
this.getProductList()
},
search(cd) {
this.$store.commit('showIsLoading');
search(`shop_cat_id=${this.shop_cat_id}&pages=${this.pages}`).then(res => {
if (res.data.error) {
alert(res.data.msg);
console.error(res);
return;
};
cd && cd(res.data.items);
});
},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
onScrollBtm() {
console.log('onScrollBtm')
console.log(this.isMoreList)
if(this.isMoreList){
this.isMoreList = false
this.pagination.page ++
this.getProductList()
}
},
getActivity () {
if(this.activityId){
Api.getActivity(this.activityId)
.then(res => {
this.activityTitle = res.data.name
this.activityThumbnail = res.data.thumbnail

wx.ready(() => {
wx.onMenuShareAppMessage({
title: this.activityTitle,
desc: '',
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.activityThumbnail,
success: function () {
}
})
wx.onMenuShareTimeline({
title: this.activityTitle,
desc: '',
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.activityThumbnail,
success: function () {
}
})
})


this.productList = res.data.products
if(this.productList.length < parseInt(res.headers.total)){
this.isMoreList = true
}else {
this.isMoreList = false
this.loadText = '没有更多数据'
}
this.$nextTick(() => {
this.$refs.scrollerEvent.reset()
})
})
}
}
},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerEvent.reset({
top: 0
})
});
this.getActivity()
}
}



// WEBPACK FOOTER //
// ./src/components/Activity/Activity.vue